import "./monaco-config";

import { library } from "@fortawesome/fontawesome-svg-core";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { createRoot } from "react-dom/client";

import { initAuthController } from "./authentication/auth-controller";

import "./theme/theme.scss";

// Add full solid and regular icon sets
library.add(fas, far);

/**
 * Entry point of the Application.
 * App (and its entire module graph — routes, Apollo clients, axios) is imported
 * dynamically AFTER initAuthController() completes, so that authController is
 * guaranteed to be set before any of those modules execute.
 */
async function init(): Promise<void> {
  await initAuthController();

  const { default: App } = await import("./App");
  createRoot(document.getElementById("root") as HTMLElement).render(App);
}

init();
